// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class PFixXmlMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_PFIX_XML_MESSAGE, fieldSet);
    }
}
